import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({providedIn: 'root'})

export class ErrorService {
  private _errorSubject = new BehaviorSubject<string | null>(null);
  public error$ = this._errorSubject.asObservable();

  public showError(message: string) {
    this._errorSubject.next(message);
    setTimeout(() => {
      this._errorSubject.next(null);
    }, 3000);
  }
}
